"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _BuilderBlock = _interopRequireDefault(require("../BuilderBlock"));
var _cog = _interopRequireDefault(require("cccisd-icons/cog"));
var _cogs = _interopRequireDefault(require("cccisd-icons/cogs"));
var _FilterFieldsBlock = _interopRequireDefault(require("./FilterFieldsBlock"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports["default"] = function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$widgets = _ref.widgets,
    widgets = _ref$widgets === void 0 ? [] : _ref$widgets,
    _ref$filterFields = _ref.filterFields,
    filterFields = _ref$filterFields === void 0 ? [] : _ref$filterFields;
  var initialValues = {
    filterFields: filterFields.map(function (f) {
      return f.name;
    })
  };
  return function (Component) {
    return function (props) {
      var _props$widgetProps = props.widgetProps,
        widgetProps = _props$widgetProps === void 0 ? {} : _props$widgetProps;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
        initialValues: _objectSpread(_objectSpread({}, initialValues), props.initialValues),
        onValidChange: props.onValidChange,
        isInitialValid: true,
        render: function render(_ref2) {
          var values = _ref2.values,
            setFieldValue = _ref2.setFieldValue;
          return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              marginBottom: '1em'
            }
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].heading
          }, /*#__PURE__*/_react["default"].createElement(_cog["default"], {
            spaceRight: true
          }), "Report Settings"), filterFields.length > 0 && /*#__PURE__*/_react["default"].createElement(_FilterFieldsBlock["default"], {
            filterFields: filterFields
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(Component, props))), /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].heading
          }, /*#__PURE__*/_react["default"].createElement(_cogs["default"], {
            spaceRight: true
          }), "Widgets"), widgets.map(function (widget) {
            var builderComponent = /*#__PURE__*/_react["default"].createElement(widget.builder, _extends({
              initialValues: _objectSpread(_objectSpread({}, widget.builderInitialValues), values.widgets[widget.handle]),
              onValidChange: function onValidChange(widgetValue) {
                setFieldValue('widgets', _objectSpread(_objectSpread({}, values.widgets), {}, _defineProperty({}, widget.handle, widgetValue)));
              }
            }, widgetProps[widget.handle]));

            // must explicitly opt-out of BuilderBlock; usually its the right choice
            if (!widget.noBuilderBlock) {
              builderComponent = /*#__PURE__*/_react["default"].createElement(_BuilderBlock["default"], {
                title: widget.label
              }, builderComponent);
            }
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: widget.handle
            }, builderComponent);
          }));
        }
      });
    };
  };
};